import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Dayjs } from 'dayjs'
import { mainContainerHeaderStyle, headerBarLeftWrapperStyle } from '@/constants/layout'
import { Button } from '@/components/atoms/button'
import { MonthSelector } from '@/components/organisms/survey/month-selector'
import { FilterPopup } from '@/components/organisms/survey/filter-popup'
import { ButtonType } from '@/components/atoms/button'
import { CompanionType, AgeGroupType } from '@/models/survey/filter-types'

const ALL_COMPANION_TYPES: CompanionType[] = ['none', 'alone', 'family', 'friend', 'partner', 'coworker', 'other']
const ALL_AGE_GROUP_TYPES: AgeGroupType[] = ['none', '10', '20', '30', '40', '50', '60', '70']

/**
 * 集計ページのヘッダーコンポーネント
 * 月選択とフィルター機能を提供
 */
type Props = {
  month: Dayjs
  onMonthChange: (month: Dayjs) => void
  companion: CompanionType[]
  ageGroup: AgeGroupType[]
  onFilterChange: (companion: CompanionType[], ageGroup: AgeGroupType[]) => void
  isFilterOpen: boolean
  onFilterOpen: () => void
  onFilterClose: () => void
}

export const SurveySummaryHeader: React.FC<Props> = ({
  month,
  onMonthChange,
  companion,
  ageGroup,
  onFilterChange,
  isFilterOpen,
  onFilterOpen,
  onFilterClose,
}) => {
  const { t } = useTranslation()

  // フィルタリング中かどうか（すべて選択されていない場合、またはすべて解除されている場合）
  const isFiltering = useMemo(() => {
    // すべて解除されている場合
    if (companion.length === 0 && ageGroup.length === 0) {
      return true
    }
    // すべて選択されている場合はフィルタリング中ではない
    const isAllCompanionSelected = ALL_COMPANION_TYPES.every(type => companion.includes(type))
    const isAllAgeGroupSelected = ALL_AGE_GROUP_TYPES.every(type => ageGroup.includes(type))
    return !isAllCompanionSelected || !isAllAgeGroupSelected
  }, [companion, ageGroup])

  return (
    <div css={mainContainerHeaderStyle}>
      <div css={headerBarLeftWrapperStyle}>
        <MonthSelector value={month} onChange={onMonthChange} />
      </div>
      <div css={filterButtonWrapperStyle}>
        <Button
          width={100}
          height={32}
          fontSize={12}
          onClick={onFilterOpen}
          icon={isFiltering ? require('@/static/images/icon_filter_active.svg') : require('@/static/images/icon_filter_disable.svg')}
          buttonType={isFiltering ? ButtonType.Simple : ButtonType.NonStyle}
        >
          {t('Filter')}
        </Button>
        <FilterPopup
          isOpen={isFilterOpen}
          onClose={onFilterClose}
          companion={companion}
          ageGroup={ageGroup}
          onChange={onFilterChange}
          customStyle={css({ marginTop: 40, right: 0 })}
        />
      </div>
    </div>
  )
}

const filterButtonWrapperStyle = css({
  position: 'relative',
})
